import { Model } from "@/models/base/model";

export class Content extends Model {
  constructor(params: any = {}) {
    super(params);
  }

  // お知らせ一覧取得
  async getNotices(size: number): Promise<any> {
    this.url = `/cms/api/contents/notices/list?size=${size}`;
    return await super.fetch();
  }

  // 記事数
  async getArticlesCount(cond: any): Promise<any> {
    this.url = `/cms/api/contents/articles/count?searchType=${cond.searchType}&searchValue=${cond.searchValue}`;
    return await super.fetch();
  }

  // 記事データ取得
  async getArticles(page: number, size: number, cond: any): Promise<any> {
    this.url = `/cms/api/contents/articles/list?searchType=${cond.searchType}&searchValue=${cond.searchValue}&page=${page}&size=${size}`;
    return await super.fetch();
  }

  // 記事検索件数取得
  async searchArticlesCount(cond: any): Promise<any> {
    const params = new URLSearchParams();

    if (cond.posterIds?.length > 0) {
      params.append("posterIds", cond.posterIds.join(","));
    }

    if (cond.tagIds?.length > 0) {
      params.append("tagIds", cond.tagIds.join(","));
    }

    if (cond.diseaseCodes?.length > 0) {
      params.append("diseaseCodes", cond.diseaseCodes.join(","));
    }

    const queryString = params.toString() ? "?" + params.toString() : "";
    this.url = `/cms/api/contents/articles/search-count${queryString}`;
    return await super.fetch();
  }

  // 記事検索
  async searchArticles(page: number, size: number, cond: any): Promise<any> {
    const params = new URLSearchParams();

    if (cond.posterIds?.length > 0) {
      params.append("posterIds", cond.posterIds.join(","));
    }

    if (cond.tagIds?.length > 0) {
      params.append("tagIds", cond.tagIds.join(","));
    }

    if (cond.diseaseCodes?.length > 0) {
      params.append("diseaseCodes", cond.diseaseCodes.join(","));
    }

    params.append("page", page.toString());
    params.append("size", size.toString());

    const queryString = params.toString() ? "?" + params.toString() : "";
    this.url = `/cms/api/contents/articles/search${queryString}`;
    return await super.fetch();
  }

  // 記事詳細取得
  async getContentDetail(articleId: number): Promise<any> {
    this.url = `/cms/api/contents/detail/${articleId}`;
    return await super.fetch();
  }

  // コンテンツ記事お気に入り更新
  async updateUserArticleFavorites(articleId: number): Promise<any> {
    this.url = "/cms/api/users/article-favorites/update";
    return await this.save({ articleId }, "POST");
  }

  // コンテンツ記事いいね登録更新
  async updateUserArticleLikes(
    articleId: number,
    is_liked: boolean
  ): Promise<any> {
    this.url = "/cms/api/users/article-likes/update";
    this.reqParams = { is_liked };
    return await this.save({ articleId }, "POST");
  }
}
